// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".checkout-component[data-v-7ed51908] {\n  display: flex;\n  flex-direction: column;\n  gap: var(--gap_big);\n}\n.checkout-component .name_form[data-v-7ed51908] {\n  display: flex;\n  flex-direction: column;\n  gap: var(--gap);\n}\n.checkout-component .name_form ul[data-v-7ed51908] {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
